import { Controller, useFormContext } from 'react-hook-form';

const CheckboxField = ({ name, label }) => {
  const { control } = useFormContext();

  return (
    <div className="form-control">
      <label className="form-control__checkbox">
        {label}
        <Controller
          render={({ field }) => (
            <input
              {...field}
              type="checkbox"
              data-testid={name}
            />
          )}
          name={name}
          control={control}
        />
        <span className="form-control__checkbox__checkmark" />
      </label>
    </div>
  );
};

export default CheckboxField;
